/**
 * Cubierta respondida y el puesto de un grupo del catalogo entre las esenciales (MADERINCO-FLUJO-SIGUIENTE-SECCION-T1;
 * Ares #30339, #30346).
 *
 * EL ORDEN ES UN DATO: el de Atenea (Cubierta -> Paredes -> Piso -> Agua y gas -> Electricidad), generado en
 * ordenDeSecciones.js desde su JSON de arboles. Un grupo toma el puesto de la primera esencial cuyos ids de catalogo
 * coinciden con los de sus partidas.
 * Josse 28-oct (#36553): la siguiente seccion ya no se sugiere desde la plantilla (la da la barra de las secciones del
 * cliente); se retiraron seccionesPendientes y siguienteSeccion.
 *
 * @module application/presupuestos/siguienteSeccion
 */
import { ESENCIALES } from './ordenDeSecciones.js';

/** Cubierta respondida = tipo elegido (no "todavia no definido") y preguntas 2 y 3 contestadas. */
export function cubiertaRespondida(c) {
  return !!(c && c.tipo && c.tipo !== 'no_definido' && c.q2 && c.q3);
}

/** El puesto de una seccion de la plantilla en el orden de las esenciales (por ids de catalogo); Infinity si no es. */
export function puestoEsencial(seccion, esenciales = ESENCIALES) {
  const ids = new Set((seccion?.items || []).map((it) => it.fuenteId).filter(Boolean));
  for (let i = 0; i < esenciales.length; i++) {
    if ((esenciales[i].fuenteIds || []).some((f) => ids.has(f))) return i;
  }
  return Number.POSITIVE_INFINITY;
}

